import { render, staticRenderFns } from "./card-doctor-details.vue?vue&type=template&id=0e2865eb"
import script from "./card-doctor-details.vue?vue&type=script&lang=js"
export * from "./card-doctor-details.vue?vue&type=script&lang=js"
import style0 from "./card-doctor-details.vue?vue&type=style&index=0&id=0e2865eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports